import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import { Feather } from "@expo/vector-icons";
import { apiservice } from "../../service/service";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilState } from "recoil";
import { useIsFocused } from "@react-navigation/native";
import Tebleeventrank from "./tebleeventrank";
const { width, height } = Dimensions.get("window");
export default function eventrank({ navigation }) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setdata] = useState([]);

  async function getevent() {
    const response = await apiservice({
      path: "/event/getallevent",
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      setdata(response.data.data);
    }
  }
  useEffect(() => {
    getevent();
  }, [focus]);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>Rank</Text>
            <TouchableOpacity onPress={() => {
              navigation.navigate('Eventrank_user')
            }}>
              <Text style={styles.textfree}>{' Public Link'}</Text>
            </TouchableOpacity>
          </View>
          <Tebleeventrank navigation={navigation} data={data} />
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "100%",
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfil: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#000",
  },
  textfilits: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
  },
  viewfil: {
    width: width * 0.83,
    backgroundColor: "#fff",
    height: 100,
    borderRadius: 10,
    marginTop: 10,
    padding: 10,
  },
});
